import { useContext, useEffect, useState } from 'react';

import ImageGallery from '../../../reusable/images/image-gallery/image-gallery.component';
import AddImage from '../../../reusable/images/add-image/add-image.component';
import ComponentModal from '../../../reusable/component-modal/component-modal.component';
import Spinner from '../../../reusable/spinner/spinner.component';
import Button from '../../../reusable/button/button.component';

import { ToastContext } from '../../../../contexts/toast.context';

import Client from '../../../../tools/client';

const client = new Client();

const LogoUploader = ({ label, configKey }) => {
  const [loading, setLoading] = useState(true);
  const [ configuration, setConfiguration ] = useState(null);
  const [logos, setLogos] = useState([]);
  const [image, setImage] = useState(null);
  const [cropData, setCropData] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const { errorToast, successToast } = useContext(ToastContext);

  useEffect(() => {
    fetchLogos();
  }, [configKey]);

  const fetchLogos = async () => {
    setLoading(true);
    const res = await client.getConfigurationByKey(configKey);
    if (res?.images) {
      const formattedImages = res.images.map((image) => ({
        ...image,
        path: image.path + '.webp'
      }));

      setLogos(formattedImages);
    }
    setConfiguration(res);
    setLoading(false);
  };

  const saveLogoImage = async (file) => {
    let formData = new FormData();
    formData.append('files', file);
    formData.append('key', configKey);

    const res = await client.addConfigurationImage(formData);
    if (res?.status === 200) {
      successToast('Logo uploaded successfully');
      fetchLogos();
      setShowAddModal(false);
    } else {
      errorToast('Failed to upload logo');
    }
  };

  const handleDeleteImage = async (id) => {
    const res = await client.deleteConfigurationEntryImage(configuration.id, id);

    if (res?.status === 200) {
      successToast('Logo deleted');
      fetchLogos();
    } else {
      errorToast('Failed to delete logo');
    }
    
    setSelectedImage(null);
  };

  const setActiveLogo = async (image) => {
    const res = await client.setConfigurationImageToActive(configuration.id, image.id);
    if (res?.status === 200) {
      successToast('Active logo updated');
      fetchLogos();
    } else {
      errorToast('Failed to update active logo');
    }
  };

  return (
    <div>
      <ComponentModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title="Upload Logo"
      >
        <AddImage
          image={image}
          setImage={setImage}
          saveImage={saveLogoImage}
          showSaveButton={true}
          setCropData={setCropData}
        />
      </ComponentModal>

      <h4>{label}</h4>
      <Button onClick={() => setShowAddModal(true)}>Add Logo</Button>

      {loading ? (
        <Spinner />
      ) : logos.length > 0 ? (
        <ImageGallery
          images={logos}
          onDelete={handleDeleteImage}
          onSetActive={setActiveLogo}
        />
      ) : (
        <p style={{ marginTop: '1rem' }}>No logo uploaded yet.</p>
      )}
    </div>
  );
};

export default LogoUploader;